import * as React from 'react'
import Icon from '../Icons/Icon'
import SimpleTooltip from './SimpleTooltip'

interface IProps {
  content: string
  containerStyle?: React.CSSProperties
}

const Tooltip = (props: IProps) => {
  const { content, containerStyle } = props

  return (
    <span style={containerStyle} >
      <SimpleTooltip content={content}>
        <span>
          <Icon icon='info' className='tooltip-info-icon' />
        </span>
      </SimpleTooltip>
    </span>
  )
}

export default Tooltip
